<template>
  <v-card class="elevation-0">
    <v-card-title>
      <span class="headline" v-if="showHeader">Letter Content</span>
      <!-- <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here"></v-text-field>-->
      <!-- <v-flex class="px-2" xs12 sm4 md4>
        <v-text-field label="Search Here" v-model="search"></v-text-field>
      </v-flex>
      <v-flex class="px-2" xs12 sm2 md2>
        <v-select
          :items="searchOptions"
          v-model="selectedSearchOption"
          item-value="value"
          item-text="text"
        ></v-select>
      </v-flex> -->
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table :items="items" :headers="headers" :search="search">
        <template v-slot:item.actions="{ item }">
          <slot name="actions" v-bind:item="item"></slot>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
const API_ENDPOINT = "/api/letterContent";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "messageCode",
        sortable: true
      },
      {
        text: "Description",
        value: "message",
        sortable: true
      },
      {
        text: "Certified By",
        value: "certifiedBy",
        sortable: true
      },
      {
        text: "Position",
        value: "certifiedPos",
        sortable: true
      }
    ],
    loading: false,
    search: "",
    searchOptions: [
      {
        text: "All",
        value: "all"
      },
      {
        text: "Code",
        value: "code"
      },
      {
        text: "Description",
        value: "desc"
      },
      {
        text: "Certified By",
        value: "certifiedBy"
      },
      {
        text: "Position",
        value: "certifiedPos"
      }
    ],
    selectedSearchOption: "all"
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.getAll();
  }
};
</script>